export default __webpack_public_path__ + "static/media/easyvacations.c8a0367b.png";